import { render, staticRenderFns } from "./AcceptModal.vue?vue&type=template&id=1feb1d02&scoped=true&"
import script from "./AcceptModal.vue?vue&type=script&lang=js&"
export * from "./AcceptModal.vue?vue&type=script&lang=js&"
import style0 from "./AcceptModal.vue?vue&type=style&index=0&id=1feb1d02&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1feb1d02",
  null
  
)

export default component.exports